// import Popper from 'popper.js';
import 'bootstrap'

import Turbolinks from 'turbolinks'

import debounced from 'debounced'

import Rails from 'rails-ujs'

import ReactOnRails from 'react-on-rails'
import './obs_style'

import $ from 'jquery'

import Checkout from '../src/checkout/Checkout'
import PayPalWarning from '../src/PayPalWarning'
Turbolinks.start()
debounced.initialize()
Rails.start()

const callback = () => {
  $('.product-col-clickable').click(function (event) {
    event.stopImmediatePropagation()
    window.location = $(this).find('.product-link').attr('href')
  })

  $('[data-toggle="popover"]').popover()

  $('input[name=size_id]').change(function () {
    const newVal = this.value

    const url = new URL(window.location.href)
    url.searchParams.set('size_id', newVal)

    Turbolinks.visit(url.toString())
  })

  window.disabled_products.forEach((id) => {
    $('#product-' + id).hide()
  })
}

document.addEventListener('turbolinks:load', callback)
window.$ = $
window.jQuery = $

ReactOnRails.register({
  Checkout,
  PayPalWarning
})
